import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Button, CopyToClipboard, Dropdown, Icon, Space } from '@binance-chain/honeycomb'

import { useI18n } from '../../i18n/util'
import { EXPLORER_URL } from '../../utils/httpRequest'
import formatAddress from '../../utils/formatAddress'
import { isUnlockWithWalletConnect } from '../../utils/account'

import {
  Profile,
  ProfileInner,
  ProfileInnerText,
  Address,
  HighlightedAddress,
  Container,
  BinanceWalletIcon,
  WalletConnectColorIcon,
  IconContainer,
  AddressForCopy,
  AddressLabel,
  AddressContainer,
  AddressOperations,
  DropdownItem,
  MainDropdownItem,
} from '../../components/walletinfo'

const WalletInfo = ({ unlock, disconnect }) => {
  const { formatI18nText } = useI18n()
  const {
    account: { address, network },
  } = useSelector(state => state)
  const [showing, setShowing] = useState(false)

  const Target = (
    <Profile>
      <ProfileInner>
        {isUnlockWithWalletConnect() ? <WalletConnectColorIcon /> : <BinanceWalletIcon />}
        {showing ? (
          <HighlightedAddress>{formatAddress(address)}</HighlightedAddress>
        ) : (
          <Address>{formatAddress(address)}</Address>
        )}
      </ProfileInner>
      {!isUnlockWithWalletConnect() && (
        <ProfileInnerText>
          {network && network.name === '' ? 'Connecting...' : network.name}
        </ProfileInnerText>
      )}
    </Profile>
  )

  if (!address || address === '') return null
  return (
    <Dropdown target={Target} onClick={() => setShowing(!showing)}>
      <MainDropdownItem>
        <Container extended={true}>
          <AddressLabel>{formatI18nText('walletInfo.address')}</AddressLabel>
          <AddressContainer>
            <AddressForCopy>{formatAddress(address, 8)}</AddressForCopy>
            <AddressOperations>
              <Space size="normal" />
              <CopyToClipboard value={address} />
              <Space size="tiny" />
              <IconContainer>
                <Button
                  href={`${EXPLORER_URL}/address/${address}`}
                  target="_blank"
                  variant="secondary"
                  shape="square"
                  size="normal"
                >
                  <Icon.ArrowTopRight />
                </Button>
              </IconContainer>
            </AddressOperations>
          </AddressContainer>
        </Container>
      </MainDropdownItem>
      <Dropdown.Divider />
      <DropdownItem onClick={unlock}>
        <Container>{formatI18nText('walletInfo.unlock')}</Container>
      </DropdownItem>
      <DropdownItem onClick={disconnect}>
        <Container>{formatI18nText('walletInfo.disconnect')}</Container>
      </DropdownItem>
    </Dropdown>
  )
}

WalletInfo.propTypes = {
  unlock: PropTypes.func.isRequired,
  disconnect: PropTypes.object.isRequired,
}

export default WalletInfo
